export const trackError = (error, action, label) => {
  return {
    label,
    action: `ERROR/${action.type}/${error.name}:${error.message}`
  }
}

export const trackActiveSort = (state, action, label) => {
  const { type, sortDir, sortRow } = action.activeSort
  const { selected } = state.search

  const typeString = type ? `/type:${type}/` : '/type:NULL/'
  const sortDirString = sortDir && `dir:${sortDir}/`
  const sortRowString = sortRow && `row:${sortRow}/`
  const selectedString = selected ? `id:${selected.id}/name:${selected.name}` : null

  return {
    label,
    action: [action.type, typeString, sortDirString, sortRowString, selectedString]
      .filter(Boolean)
      .join('')
  }
}

export const trackDeselectValue = (action, label) => {
  return { label, action: `${action.type}` }
}

export const trackSelectValue = (state, action, label) => {
  const { name, id } = getGaSelectValueString(state)
  const { selected } = action

  return {
    label,
    action: `${action.type}/id:${selected[id] || null}/name:${selected[name] || null}`
  }
}

const getGaSelectValueString = state => {
  const { parameters } = state
  const { fields } = parameters || null
  if (!fields) return { name: null, id: null }

  const nameRow = fields.find(field => field.role === 'name')
  const idRow = fields.find(field => field.role === 'id')

  return {
    name: nameRow && nameRow.id ? nameRow.id : null,
    id: idRow && idRow.id ? idRow.id : null
  }
}



// WEBPACK FOOTER //
// ./src/shared/middlewares/analytics/trackActions.js